import { c as _c } from "react/compiler-runtime";
import { ArrowUpRight01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { NavigationMenu, NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuTrigger, navigationMenuTriggerStyle } from "@matsuricon/ui/navigation-menu";
import { cn } from "@matsuricon/ui/utils";
import Link from "next/link";
import { DesktopGroupContent } from "./desktop-group-content";
import { isNavGroup, type NavItem } from "./navigation-data";
import { containsCurrentPath, isCurrentPath } from "./navigation-utils";
type DesktopNavigationProps = {
  items: readonly NavItem[];
  pathname: string;
};
export function DesktopNavigation(t0) {
  const $ = _c(7);
  const {
    items,
    pathname
  } = t0;
  let t1;
  if ($[0] !== items || $[1] !== pathname) {
    let t2;
    if ($[3] !== pathname) {
      t2 = item => isNavGroup(item) ? <NavigationMenuItem key={item.label}><NavigationMenuTrigger className={cn("bg-transparent font-sans text-sm tracking-normal", containsCurrentPath(item, pathname) && "text-primary")}>{item.label}</NavigationMenuTrigger><NavigationMenuContent><DesktopGroupContent group={item} pathname={pathname} /></NavigationMenuContent></NavigationMenuItem> : <NavigationMenuItem key={item.href}><NavigationMenuLink asChild={true}>{item.external ? <a className={cn(navigationMenuTriggerStyle(), "gap-1.5 bg-transparent font-sans text-sm tracking-normal")} href={item.href}>{item.label}<HugeiconsIcon aria-hidden="true" icon={ArrowUpRight01Icon} strokeWidth={1.8} /><span className="sr-only"> (external site)</span></a> : <Link aria-current={isCurrentPath(pathname, item.href) ? "page" : undefined} className={cn(navigationMenuTriggerStyle(), "bg-transparent font-sans text-sm tracking-normal", isCurrentPath(pathname, item.href) && "text-primary")} href={item.href}>{item.label}</Link>}</NavigationMenuLink></NavigationMenuItem>;
      $[3] = pathname;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = items.map(t2);
    $[0] = items;
    $[1] = pathname;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="hidden min-w-0 flex-1 justify-end xl:flex"><NavigationMenu aria-label="Main" delayDuration={120} skipDelayDuration={120} viewport={false}><NavigationMenuList>{t1}</NavigationMenuList></NavigationMenu></div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}